<template lang="pug">
div
  .van-popup__header
    .van-popup__header__title {{ $t("iq.rangeTitle") }}
    .van-popup__header__cancel(@click='$emit("close")') {{ $t("iq.cancel") }}
    .van-popup__header__confirm(@click='setIQRange') {{ $t("iq.confirm") }}
  .iq__range
    vue-slider(
      v-model='value',
      tooltip='always'
      :min='min',
      :max='max',
      :minRange="5"
      :enable-cross='false'
      :duration='0'
    )
    .iq__range__bar
      .iq__range__bar__item.iq__range__bar__success(:style='{ width: successWidth }')
      .iq__range__bar__item.iq__range__bar__warning(:style='{ width: warningWidth }')
      .iq__range__bar__item.iq__range__bar__danger(:style='{ width: dangerWidth }')

  .iq__legend
    .iq__legend__item.iq__legend__success {{ $t("iq.good") }}
    .iq__legend__item.iq__legend__warning {{ $t("iq.regular") }}
    .iq__legend__item.iq__legend__danger {{ $t("iq.bad") }}

  .iq__reset(@click="setDefaultIQRange")
    | {{ $t("iq.default") }}
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { IAQ } from '@/app.config';

export default {
  components: { VueSlider },
  props: {
    iqLow: {
      type: Number,
      default: IAQ.LOW,
    },
    iqHigh: {
      type: Number,
      default: IAQ.HIGH,
    },
  },

  data() {
    return {
      value: [this.iqLow, this.iqHigh],
      min: IAQ.MIN,
      max: IAQ.MAX,
      default: [IAQ.LOW, IAQ.HIGH],
    };
  },

  computed: {
    successWidth() {
      return `${(this.value[0] * 100) / this.max}%`;
    },

    dangerWidth() {
      return `${((this.max - this.value[1]) * 100) / this.max}%`;
    },

    warningWidth() {
      return `${((this.value[1] - this.value[0]) * 100) / this.max}%`;
    },
  },

  methods: {
    setDefaultIQRange() {
      this.value = this.default;
    },

    setIQRange() {
      const aqRange = {
        low: this.value[0],
        high: this.value[1],
      };

      this.$emit('setIQRange', aqRange);
    },
  },
};
</script>

<style lang="scss">
.vue-slider-rail,
.vue-slider-process {
  background-color: transparent;
}

.vue-slider-dot-tooltip-inner {
  padding: 0;
  color: #4c5153;
  background-color: transparent;
  border-color: transparent;
}

.vue-slider-dot-tooltip-top {
  top: -5px;
}
</style>
